'use client';

import Link from 'next/link';
import { trackSectionCta } from '@/components/GoogleAnalytics';

export default function HomeCommunitySection() {
  return (
    <section className="relative overflow-hidden py-16 font-sans text-white md:py-20">
      <div
        aria-hidden
        className="absolute inset-0 bg-[linear-gradient(180deg,#ED3D94_0%,#A50C45_100%)] lg:bg-[linear-gradient(90deg,#ED3D94_0%,#A50C45_100%)]"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-repeat"
        style={{ backgroundImage: "url('/assets/img/moroccan-bg.png')" }}
      />

      <div className="relative z-10 mx-auto w-full max-w-[1120px] px-5 text-center md:px-8">
        <p className="text-[13px] font-semibold uppercase tracking-[2px]">Join our community</p>
        <h2 className="mx-auto mt-3 text-[28px] font-bold leading-tight md:text-[40px]">
          आजच आपला जोडीदार शोधा
          <br />
          नोंदणी पूर्णपणे मोफत
        </h2>
        <p className="mx-auto mt-4 max-w-[28ch] text-[15px] leading-relaxed text-white md:mt-5 md:max-w-none md:text-[16px]">
          Registration is 100% Free &amp; takes only 2 minutes to complete.
        </p>
        <Link
          href="/register"
          onClick={() =>
            trackSectionCta('click_register', 'homepage_community_section', 'Register Now in 2 minutes')
          }
          className="mt-8 inline-flex w-full items-center justify-center rounded-full border border-white bg-primary-600 px-8 py-3.5 text-[16px] font-semibold text-white transition-colors hover:bg-primary-700 md:mt-10 md:w-auto md:px-10"
        >
          Register Now in 2 minutes
        </Link>
        <p className="mt-5 text-[13px] text-white/85 md:text-[14px]">Join 10,000+ Marathi families who trust us</p>
      </div>
    </section>
  );
}
